<div class="flex-row-container">
  @for (activeFilter of activeFilters; track activeFilter) {
    <button
      class="filter-pill"
      (click)="removeFilter(activeFilter.filterType, activeFilter.filter)"
      id="remove-filter-{{ activeFilter.display }}"
    >
      <span class="visuallyhidden">Remove filter</span> {{ activeFilter.display | titlecase }}
      <i class="ico-cancel"></i>
    </button>
  }
</div>
